//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    padding: 10px 30px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;